import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Carousel } from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css';

import SafetyCertificateFilled from "@ant-design/icons/es/icons/SafetyCertificateFilled";
import { MAX_CLIENT_WIDTH, TAGS_TYPE } from "../../../../Enums";

import "./DetailIndex.css";

import {
    Button,
    Tooltip
} from '@material-ui/core';
import { RoutePath } from "../../../../../../constants/RoutePath";
import { getZone } from "../../../../actions/ZoneAction";
import { MoneyFormat } from "../../../../../../utils/NumberUtil";
import HttpUtils from "../../../../../../utils/HttpUtils";
import LocationOnOutlined from '@material-ui/icons/LocationOnOutlined';
import ZoneTag from "../components/ZoneTag";
import ZoneNearBy from "./ZoneNearBy";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import BrokerInfoParts from "./BrokerInfoParts";
import heartPng from '../../../../../../images/mine/heart.png'
import heartOutLinePng from '../../../../../../images/mine/heartOutLine.png'
import { addFavoriteApi, cancelFavoriteApi, verifyFavoriteApi } from '../../../../WebService';
import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from '../../../../../../constants/Profile';
import { message } from 'antd';
import limitPng from '../../../../../../images/detail/limit.png'

const noImageUrl = require("../../../../../../images/照片采集中.png");
const heightIconUrl = require("../../../../../../images/detail/净高.svg");
const buildingAreaIconUrl = require("../../../../../../images/detail/总建筑面积.svg");
const buildingTypeIconUrl = require("../../../../../../images/detail/建筑类型.svg");
const platformIconUrl = require("../../../../../../images/detail/月台高度.svg");
const fireRatingIconUrl = require("../../../../../../images/detail/耐火.svg");
const loadIconUrl = require("../../../../../../images/detail/荷载.svg");

class DetailIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formatMessage: this.props.intl['formatMessage'],
            showBuildingTooltip: false,
            // imgHeight: 200,
            isCollect: false
        }
    }

    componentWillMount() {
        this.props.dispatch(getZone(this.props.router.params.id, this.state.formatMessage));
        const token = localStorage.getItem(CACHE_ACCESS_TOKEN)
        if (token) {
            this.getCollectStatus();
        }
    }

    getCollectStatus() {
        HttpUtils.post(verifyFavoriteApi, { zoneId: this.props.router.params.id }, (res) => {
            this.setState({
                isCollect: !!res.data
            })
        })
    }

    collectHandle() {
        const token = localStorage.getItem(CACHE_ACCESS_TOKEN)
        if (token) {
            let collect = this.state.isCollect;
            let url = collect ? cancelFavoriteApi : addFavoriteApi
            HttpUtils.post(url, { zoneId: this.props.router.params.id }, () => {
                message.success(collect ? '取消收藏成功' : '收藏成功')
                this.setState({
                    isCollect: !collect
                })
            }, () => { })

        } else {

            sessionStorage.setItem('collectZoneId', this.props.router.params.id)
            this.loginHandle()
        }
    }

    render() {

        let limit = this.props.limit

        if (limit) {
            return this.tip()
        }

        const zone = this.props.zone ? this.props.zone : {};
        const isCollect = this.state.isCollect

        let thisClientWidth = document.documentElement.clientWidth > MAX_CLIENT_WIDTH ? MAX_CLIENT_WIDTH : document.documentElement.clientWidth;
        let sellingPointList = zone.sellingPointList;
        let sellingPoint = "(暂无)";
        if (sellingPointList && sellingPointList.length > 0) {

            sellingPoint = sellingPointList[sellingPointList.length - 1].content;
            sellingPointList.forEach(item => {
                if (item.mainFlag == 1) {
                    sellingPoint = item.content;
                }
            })

        }
        let photoUrlList = zone.photoFiles && zone.photoFiles.length > 0 ?
            zone.photoFiles.map(item => item.url + "?x-oss-process=style/Image_w400h300PNG") : [noImageUrl];
        const items = [];
        if (zone.district) {
            items.push(zone.district);
        }
        if (zone.town) {
            items.push(zone.town);
        }
        let simpleBuildingInfoParts = zone.buildingInfo;
        let simpleBuildingInfo = zone.buildingSimpleInfo;
        if (simpleBuildingInfo !== zone.buildingInfo) {

            simpleBuildingInfoParts = <ClickAwayListener
                onClickAway={() => this.setState({ showBuildingTooltip: false })}>
                <Tooltip title={zone.buildingInfo} placement="bottom"
                    PopperProps={{
                        disablePortal: true,
                    }}
                    onClose={() => this.setState({ showBuildingTooltip: false })}
                    open={this.state.showBuildingTooltip}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener>
                    <span onClick={() => this.setState({ showBuildingTooltip: true })} ref={this}>{simpleBuildingInfo}
                        <InfoOutlinedIcon /></span></Tooltip>
            </ClickAwayListener>;
        }


        return (

            <div className='zone-detail-page'>
                <div className='detail-image-box'>
                    <div className='detail-image-list'>
                        <Carousel
                            autoplay={false}
                            infinite
                            beforeChange={(from, to) => console.log(`slide from ${from} to ${to}`)}
                            afterChange={index => console.log('slide to', index)}>
                            {
                                photoUrlList.map((urlPath, index) => {
                                    return (
                                        <img style={{ width: "100%" }} key={index}
                                            src={urlPath}
                                            onLoad={() => {
                                                // fire window resize event to change height
                                                window.dispatchEvent(new Event('resize'));
                                                this.setState({ imgHeight: 'auto' });
                                            }} />
                                    )
                                })
                            }
                        </Carousel>
                    </div>
                    <div className='detail-image-footer'>
                        <div className='detail-image-footer-number'>
                            <SafetyCertificateFilled
                                className="detail-image-footer-number-icon" /> 房源编号&nbsp;#{zone.number}
                        </div>
                        <div className='detail-image-footer-last-time'>

                            <div>上次更新时间:</div>
                            <div>{zone.rentLatestModify}</div>
                            <div onClick={() => { this.collectHandle() }} className='collect-btn'>
                                {
                                    isCollect ? <img src={heartPng} /> : <img src={heartOutLinePng} />
                                }
                                <span>我的收藏</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="detail-summary-box">
                    <div className="detail-title-box">
                        <div className="detail-title-item-3">
                            <div>
                                <span
                                    className="detail-title-item-value">{zone.rentShow} </span>
                                <span
                                    className="detail-title-item-unit">{zone.rentShow === '面议' ? " " : "元/m²/天"}</span>
                            </div>

                            <div className="detail-title-item-name">预计有效租金-不含税含物业</div>

                        </div>
                        <div className="detail-title-item-2">
                            <div>
                                <span
                                    // className="detail-title-item-value">{MoneyFormat.formatThreeByComma(zone.vacantArea)} </span>
                                    className="detail-title-item-value" style={{ fontSize: '5vw' }}>{zone.vacantAreaMobileStr} </span>
                                {/* <span className="detail-title-item-unit">m²</span> */}
                            </div>

                            <div className="detail-title-item-name">空置面积 m²</div>

                        </div>
                        <div className="detail-title-item-2">
                            {zone.subleaseArea > 0 ?
                                <div>
                                    <div>
                                        <span
                                            className="detail-title-item-value">{MoneyFormat.formatThreeByComma(zone.subleaseArea)} </span>
                                        <span
                                            className="detail-title-item-unit">m²</span></div>

                                    <div className="detail-title-item-name">可转租面积</div>
                                </div> : null}

                        </div>
                    </div>
                    <div className="detail-title-zone-name">
                        {zone.name}

                    </div>
                    <div className="detail-title-zone-address"><LocationOnOutlined /> {items.join("-")}</div>

                    <div className="detail-title-zone-tag">
                        {zone.subleaseArea ? <ZoneTag text="部分面积可转租" color={"#c10001"} /> : null}
                        {
                            zone && zone.tags && zone.tags.split(',').map((item, index) => {
                                return <ZoneTag key={index} text={TAGS_TYPE.Map[item].label} color={TAGS_TYPE.Map[item].colorStyle.color} backgroundColor={TAGS_TYPE.Map[item].colorStyle.backgroundColor} />
                            })
                        }
                        {/* {
                            zone.tagList ? zone.tagList.filter(item => TAGS_TYPE.Map[item]).map((item, index) => {
                                // if((zone.subleaseArea&&index>=3)||index>=){//超过三个就不显示了
                                //     if (index === zone.tagList.length - 1) {
                                //         return "...";
                                //     } else {
                                //         return null;
                                //     }
                                // }
                                return (
                                    <ZoneTag key={index} text={TAGS_TYPE.Map[item].label} />
                                )
                            }) : null
                        } */}
                    </div>

                </div>
                <div className="detail-line" />

                {zone.buildingInfo === "" ? <div className="detail-building-box">
                    <div className="detail-sub-title">
                        园区规格
                    </div>
                    <div className="detail-building-row">
                        {this._renderBuildingItem("总建筑面积(m²)", buildingAreaIconUrl, MoneyFormat.formatThreeByComma(zone.buildingArea))}
                        {/*{this._renderBuildingItem2("建筑类型", buildingTypeIconUrl, simpleBuildingInfoParts)}*/}
                        {/*{this._renderBuildingItem("耐火等级", fireRatingIconUrl, zone.buildingFireRating)}*/}
                    </div>

                </div> : <div className="detail-building-box">
                    <div className="detail-sub-title">
                        园区规格
                    </div>
                    <div className="detail-building-row">
                        {this._renderBuildingItem("总建筑面积(m²)", buildingAreaIconUrl, MoneyFormat.formatThreeByComma(zone.buildingArea))}
                        {this._renderBuildingItem2("建筑类型", buildingTypeIconUrl, simpleBuildingInfoParts)}
                        {this._renderBuildingItem("耐火等级", fireRatingIconUrl, zone.buildingFireRating)}
                    </div>
                    <div className="detail-building-row">
                        {this._renderBuildingItem("月台高度(m)", platformIconUrl, zone.buildingPlatform && zone.buildingPlatform.replaceAll('m', ''))}
                        {this._renderBuildingItem2("净高(m)", heightIconUrl, zone.buildingFloorHeight && zone.buildingFloorHeight.replaceAll('m', ''))}
                        {this._renderBuildingItem("承重(t/m²)", loadIconUrl, zone.buildingFloorLoad && zone.buildingFloorLoad.replaceAll('t/m²', ""))}


                    </div>
                </div>}

                <BrokerInfoParts broker={zone.broker} zone={zone} />
                <div className="detail-line" />
                <div className="detail-building-box">
                    <div className="detail-sub-title">
                        园区位置及周边
                    </div>
                    <ZoneNearBy zone={zone} />

                </div>


            </div>
        );
    }
    loginHandle() {
        this.props.router.navigate({
            pathname: `/login`,
            search: `?redirect=${encodeURIComponent(window.location.pathname)}`,
        })
        // this.props.router.navigate('/login');
    }

    tip() {
        let [type, count] = this.props.limit.split('_')
        const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER)) || {}
        let isLogin = !!(user && user.id)
        let authStatus = this.props.authStatus
        return (
            <>
                <div className='tipWrap'>
                    <img src={limitPng} className='tipImage' />
                    <div>
                        访问次数已达上限
                    </div>
                    <div>
                        当前
                        {!isLogin && '未登录'}
                        {authStatus ? '已认证' : '未认证'}
                        ，搜索次数已达上限 ({count}次/天)
                    </div>
                    <div>
                        {!isLogin && '登录后'}
                        {isLogin && !authStatus && '电脑端访问，认证后'}，可使用更多搜索次数
                    </div>
                    {!isLogin && (
                        <div
                            onClick={() => { this.loginHandle() }}
                        >
                            登录/注册
                        </div>
                    )}
                </div>
            </>
        )
    }

    _renderBuildingItem(name, icon, value) {
        return (<div className="detail-building-item">
            <div className="detail-building-item-info">
                <span className="item-icon"><img src={icon} /></span>
                <span className="item-value">{value}</span>
            </div>
            <div className="detail-building-item-name">
                {name}
            </div>
        </div>)
    }

    _renderBuildingItem2(name, icon, value) {
        return (<div className="detail-building-item2">
            <div className="detail-building-item-info">
                <span className="item-icon"><img src={icon} /></span>
                <span className="item-value">{value}</span>
            </div>
            <div className="detail-building-item-name">
                {name}
            </div>
        </div>)
    }


}

function mapStateToProps(store) {
    return {
        zone: store.WMSZoneReducer.zone,
        limit: store.WMSZoneReducer.limit,
    }
}

export default connect(mapStateToProps)(injectIntl(DetailIndex));